import { css } from '@emotion/react';

const makeThankYouPageStyling = (
  theme,
  lottieAnimationDataAndRendererReady
) => {
  const { desktopSmall, tabletSmall } = theme.breakpoints.values;

  return {
    submissionGridContainer: css({
      backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      '& ol li::before': {
        height: `${theme.mvf.fontSize.medium + 6}px !important`,
        width: `${theme.mvf.fontSize.medium + 6}px !important`,
        lineHeight: `${theme.mvf.fontSize.medium + 6}px !important`,
      },
      '& lottie-player': {
        ...(lottieAnimationDataAndRendererReady && {
          opacity: '1 !important',
          [theme.breakpoints.up(desktopSmall)]: {
            height: '150px !important',
          },
          [theme.breakpoints.between(tabletSmall, desktopSmall)]: {
            height: '120px !important',
          },
          [theme.breakpoints.between(0, tabletSmall)]: {
            height: '90px !important',
          },
        }),
      },
    }),
    bannerContainer: css({
      '& .MuiSvgIcon-root:first-of-type': {
        marginTop: 15,
        ...(lottieAnimationDataAndRendererReady && {
          display: 'none',
        }),
      },
    }),
    submissionSummaryContainer: {
      marginTop: 10,
    },
    thankYouPageContentDownloadContainer: css({
      height: 55,
    }),
    viewWhitepaperSection: css({
      margin: '50px auto',
    }),
  };
};

export default makeThankYouPageStyling;
